<div class="crown-wrapper">
  <ng-container *ngFor="let crown of displayCrownsPlayer1; let i = index">
    <img
      src="assets/img/royal-crown.png"
      alt="crown-player1"
      class="img-crown crown-player1 animate-crown"
      [ngClass]="getPlayer1Class(i)"
      *ngIf="displayCrownsPlayer1[i]"
    />
  </ng-container>

  <ng-container *ngFor="let crown of displayCrownsPlayer2; let i = index">
    <img
      src="assets/img/royal-crown.png"
      alt="crown-player2"
      class="img-crown crown-player2 animate-crown"
      [ngClass]="getPlayer2Class(i)"
      *ngIf="displayCrownsPlayer2[i]"
    />
  </ng-container>

  <img
    src="assets/img/kevin.png"
    alt="player1"
    class="img-player img-player1-crowns animate-player1-head"
  />
  <img
    src="assets/img/steven.png"
    alt="player2"
    class="img-player img-player2-crowns animate-player2-head"
  />
</div>
